// toTitleCase converts a string to be title case
export const toTitleCase = (str: string) => {
  if (!str || str.length === 0) return ""
  return str?.[0].toUpperCase() + str.slice(1).toLowerCase()
}
